import {graphql, useStaticQuery} from "gatsby";


const useIndexData = () => {
    const data = useStaticQuery(graphql`
    query MyQuery {
    strapiCreator {
        title
        description
        ctaText
        modalType
        topCard {
          title
          description
          image {
            url
          }
          backgroundShape {
            color
            shapeId
            side
          }
          sectionPadding
        }
        middleCards {
          title
          description
          image {
            url
          }
          backgroundShape {
            color
            shapeId
            side
          }
          sectionPadding
        }
        customerLogos {
          title
          logos {
            url
          }
          sectionPadding
        }
        requestDemoSection {
          title
          subtitle
          ctaText
        }
      }
      strapiFooter {
        columns {
          title
          links {
            text
            url
          }
        }
        backgroundShapes {
            color
            shapeId
            side
        }
      }
    }`);
    return data;
};

export default useIndexData;
